import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Product', prop: 'product_id', references: 'admin/products', referenceProp: 'name' },
  { title: 'Discount', prop: 'discount_id', references: 'admin/discounts', referenceProp: 'code' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by product', prop: 'filters.product_id', type: 'autocomplete', references: 'admin/products', referenceProp: 'name', enabled: true },
  { name: 'Filter by discounts', prop: 'filters.discount_id', type: 'autocomplete', references: 'admin/discounts', referenceProp: 'name', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const ProductDiscounts = (props) => (
  <List
    title='Product Discounts'
    apiPath='admin/product_discounts'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default ProductDiscounts
